import { render, staticRenderFns } from "./ViewDocumentsModal.vue?vue&type=template&id=4721cc36&scoped=true&"
import script from "./ViewDocumentsModal.vue?vue&type=script&lang=js&"
export * from "./ViewDocumentsModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewDocumentsModal.vue?vue&type=style&index=0&id=4721cc36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4721cc36",
  null
  
)

export default component.exports